import { useCommonData } from "../../components/layout/CommonDataProvider";
import { getSearchConfig } from "../searchApi/searchConfig";

export const useSearchConfig = () => {
  const site = useCommonData().site;
  return getSearchConfig(site);
};
